// Slovak date formatting for due/end timestamps. Extracted from App.jsx (v20 §12).
export const SK_MONTHS_NOM = ["január", "február", "marec", "apríl", "máj", "jún", "júl", "august", "september", "október", "november", "december"];
export const SK_WEEKDAYS = ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"];
export const SK_MONTHS_GEN = ["januára", "februára", "marca", "apríla", "mája", "júna", "júla", "augusta", "septembra", "októbra", "novembra", "decembra"];
// v2 — "Streda, 1. júla" (weekday + day + genitive month) for the Lite Dnes header
export function fmtDayLong(dateStr) {
  const d = dateStr ? new Date(dateStr + "T00:00:00") : new Date();
  return `${SK_WEEKDAYS[d.getDay()]}, ${d.getDate()}. ${SK_MONTHS_GEN[d.getMonth()]}`;
}

export function fmtDuePretty(due, end) {
  if (!due) return "";
  const p = due.slice(0, 10).split("-");
  if (p.length < 3) return due;
  const day = parseInt(p[2], 10), mon = parseInt(p[1], 10) - 1, yr = parseInt(p[0], 10);
  const t = due.length >= 16 ? due.slice(11, 16) : "";
  const endT = end && end.length >= 16 ? end.slice(11, 16) : "";
  const sameDay = end && end.slice(0, 10) === due.slice(0, 10);
  // v20 §12 — slovenský formát: deň, mesiac, rok a čas (rok len ak nie je tento)
  const thisYear = new Date().getFullYear();
  const yrPart = yr && yr !== thisYear ? ` ${yr}` : "";
  let out = `${day}. ${SK_MONTHS_NOM[mon] || ""}${yrPart}`;
  if (t) out += ` · ${t}`;
  if (end) {
    if (sameDay) { if (endT) out += `–${endT}`; }
    else {  // multi-day udalosť → ukáž aj koniec (dátum + čas)
      const ep = end.slice(0, 10).split("-");
      const eday = parseInt(ep[2], 10), emon = parseInt(ep[1], 10) - 1, eyr = parseInt(ep[0], 10);
      const eYrPart = eyr && eyr !== thisYear ? ` ${eyr}` : "";
      out += ` – ${eday}. ${SK_MONTHS_NOM[emon] || ""}${eYrPart}` + (endT ? ` · ${endT}` : "");
    }
  }
  return out;
}
